// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListedModalPicContentAdd_modal_container__1lvCm .ant-modal-content {
    width: 100%;
    height: 820px;
    border-radius: 20px;
}

.ComponentListedModalPicContentAdd_modal_container__1lvCm .ant-modal-body {
    width: 100%;
    height: 93%;
}

.ComponentListedModalPicContentAdd_container__3Rs1P {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.ComponentListedModalPicContentAdd_main__w3Ky4 {
    display: flex;
    width: 100%;
    height: 90%;
}

.ComponentListedModalPicContentAdd_footer__pHkRA {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 7%;
    border-top: 1px solid #ccc;
}

.ComponentListedModalPicContentAdd_main_left__Q3aJd,
.ComponentListedModalPicContentAdd_main_right__qY9KH {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    width: 50%;
    height: 100%;
}

.ComponentListedModalPicContentAdd_preview_img_container__DRz9M {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 93%;
    padding-bottom: 15px;
}

.ComponentListedModalPicContentAdd_preview_img_box__DAFnm {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 85%;
}

.ComponentListedModalPicContentAdd_preview_img_name_box__tqKdk {
    width: 100%;
    height: 15%;
    padding: 10px 50px 0 50px;
}

.ComponentListedModalPicContentAdd_preview_img__HTNUD {
    max-width: 100%;
    max-height: 100%;
}

.ComponentListedModalPicContentAdd_detail_card__mhAoe .ant-card-meta-detail .ant-card-meta-title {
    font-size: 12px;
    white-space: wrap;
}

.ComponentListedModalPicContentAdd_detail_card__mhAoe .ant-card-cover {
    max-width: 100%;
    max-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ComponentListedModalPicContentAdd_right_top__yGDhr {
    width: 100%;
    height: 40%;
}

.ComponentListedModalPicContentAdd_right_bottom__Abt9x {
    width: 100%;
    height: 60%;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedModalPicContentAdd_right_bottom__Abt9x::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedModalPicContentAdd_right_bottom__Abt9x::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedModalPicContentAdd_right_bottom__Abt9x::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedModalPicContentAdd_card_add_img_box__TTJDm {
    width: 100%;
    height: 100%;
}

.ComponentListedModalPicContentAdd_components_add_img__Af3oZ {

}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListedModalPicContentAdd/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,2EAAkC,UAAU;IACxC,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,iFAAwC,WAAW;IAC/C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;AAEA","sourcesContent":[".modal_container :global(.ant-modal-content) {\n    width: 100%;\n    height: 820px;\n    border-radius: 20px;\n}\n\n.modal_container :global(.ant-modal-body) {\n    width: 100%;\n    height: 93%;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.main {\n    display: flex;\n    width: 100%;\n    height: 90%;\n}\n\n.footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 7%;\n    border-top: 1px solid #ccc;\n}\n\n.main_left,\n.main_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 50%;\n    height: 100%;\n}\n\n.preview_img_container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 93%;\n    padding-bottom: 15px;\n}\n\n.preview_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 85%;\n}\n\n.preview_img_name_box {\n    width: 100%;\n    height: 15%;\n    padding: 10px 50px 0 50px;\n}\n\n.preview_img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.detail_card :global(.ant-card-meta-detail .ant-card-meta-title) {\n    font-size: 12px;\n    white-space: wrap;\n}\n\n.detail_card :global(.ant-card-cover) {\n    max-width: 100%;\n    max-height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.right_top {\n    width: 100%;\n    height: 40%;\n}\n\n.right_bottom {\n    width: 100%;\n    height: 60%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.right_bottom::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.right_bottom::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.right_bottom::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.card_add_img_box {\n    width: 100%;\n    height: 100%;\n}\n\n.components_add_img {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ComponentListedModalPicContentAdd_modal_container__1lvCm`,
	"container": `ComponentListedModalPicContentAdd_container__3Rs1P`,
	"main": `ComponentListedModalPicContentAdd_main__w3Ky4`,
	"footer": `ComponentListedModalPicContentAdd_footer__pHkRA`,
	"main_left": `ComponentListedModalPicContentAdd_main_left__Q3aJd`,
	"main_right": `ComponentListedModalPicContentAdd_main_right__qY9KH`,
	"preview_img_container": `ComponentListedModalPicContentAdd_preview_img_container__DRz9M`,
	"preview_img_box": `ComponentListedModalPicContentAdd_preview_img_box__DAFnm`,
	"preview_img_name_box": `ComponentListedModalPicContentAdd_preview_img_name_box__tqKdk`,
	"preview_img": `ComponentListedModalPicContentAdd_preview_img__HTNUD`,
	"detail_card": `ComponentListedModalPicContentAdd_detail_card__mhAoe`,
	"right_top": `ComponentListedModalPicContentAdd_right_top__yGDhr`,
	"right_bottom": `ComponentListedModalPicContentAdd_right_bottom__Abt9x`,
	"card_add_img_box": `ComponentListedModalPicContentAdd_card_add_img_box__TTJDm`,
	"components_add_img": `ComponentListedModalPicContentAdd_components_add_img__Af3oZ`
};
export default ___CSS_LOADER_EXPORT___;
